import { Car } from "../shared-types";

export const defaultCar: Car = {
  id: "default",
  name: "Choose model from dropdown",
  label: "Choose model from dropdown",
  value: "Choose model from dropdo",
  power: 0,
  consumption: 0,
  range: 0,
  img: '',
};

export const cars: Car[] = [
  {
    id: "VW ID.3 Pro",
    name: "VW ID.3 Pro ®",
    label: "VW ID.3 Pro ®",
    value: "VW ID.3 Pro",
    power: 58,
    consumption: 15.7,
    range: 414,
    img: '',
  },
  {
    id: "VW ID.3 Pro Performance",
    name: "VW ID.3 Pro Performance ®",
    label: "VW ID.3 Pro Performance ®",
    value: "VW ID.3 Pro Performance",
    power: 58,
    consumption: 15.8,
    range: 409,
    img: '',
  },
  {
    id: "VW ID.3 Pro S",
    name: "VW ID.3 Pro S ®",
    label: "VW ID.3 Pro S ®",
    value: "VW ID.3 Pro S",
    power: 77,
    consumption: 16.2,
    range: 548,
    img: '',
  },
  {
    id: "VW ID.4 Pure",
    name: "VW ID.4 Pure ®",
    label: "VW ID.4 Pure ®",
    value: "VW ID.4 Pure",
    power: 52,
    consumption: 17,
    range: 341,
    img: '',
  },
  {
    id: "VW ID.4 Pure Performance",
    name: "VW ID.4 Pure Performance ®",
    label: "VW ID.4 Pure Performance ®",
    value: "VW ID.4 Pure Performance",
    power: 52,
    consumption: 17,
    range: 341,
    img: '',
  },
  {
    id: "VW ID.4 Pro Perormance",
    name: "VW ID.4 Pro Perormance ®",
    label: "VW ID.4 Pro Perormance ®",
    value: "VW ID.4 Pro Perormance",
    power: 77,
    consumption: 17.8,
    range: 506,
    img: '',
  },
  {
    id: "VW ID.4 GTX",
    name: "VW ID.4 GTX ®",
    label: "VW ID.4 GTX ®",
    value: "VW ID.4 GTX",
    power: 77,
    consumption: 18,
    range: 482,
    img: '',
  },
  {
    id: "VW E-Crafter",
    name: "VW E-Crafter ®",
    label: "VW E-Crafter ®",
    value: "VW E-Crafter",
    power: 35.8,
    consumption: 29.1,
    range: 115,
    img: '',
  },
  {
    id: "VW e-up!",
    name: "VW e-up! ®",
    label: "VW e-up! ®",
    value: "VW e-up!",
    power: 32,
    consumption: 14.5,
    range: 258,
    img: '',
  },
  {
    id: "Tesla Model 3",
    name: "Tesla Model 3 ®",
    label: "Tesla Model 3 ®",
    value: "Tesla Model 3",
    power: 57,
    consumption: 14.4,
    range: 495,
    img: '',
  },
  {
    id: "Tesla Model 3 Maximale Reichweite",
    name: "Tesla Model 3 Maximale Reichweite ®",
    label: "Tesla Model 3 Maximale Reichweite ®",
    value: "Tesla Model 3 Maximale Reichweite",
    power: 76,
    consumption: 14.7,
    range: 614,
    img: '',
  },
  {
    id: "Tesla Model 3 Performance",
    name: "Tesla Model 3 Performance ®",
    label: "Tesla Model 3 Performance ®",
    value: "Tesla Model 3 Performance",
    power: 76,
    consumption: 16.5,
    range: 305,
    img: '',
  },
  {
    id: "Hyundai Kona Elektro 39.2 kWh",
    name: "Hyundai Kona Elektro 39.2 kWh ®",
    label: "Hyundai Kona Elektro 39.2 kWh ®",
    value: "Hyundai Kona Elektro 39.2 kWh",
    power: 39.2,
    consumption: 14.3,
    range: 484,
    img: '',
  },
  {
    id: "Hyundai Kona Elektro 64 kwh",
    name: "Hyundai Kona Elektro 64 kwh ®",
    label: "Hyundai Kona Elektro 64 kwh ®",
    value: "Hyundai Kona Elektro 64 kwh",
    power: 64,
    consumption: 14.7,
    range: 484,
    img: '',
  },
  {
    id: "Renault Zoe R110 Z.E. 40",
    name: "Renault Zoe R110 Z.E. 40 ®",
    label: "Renault Zoe R110 Z.E. 40 ®",
    value: "Renault Zoe R110 Z.E. 40",
    power: 41,
    consumption: 17.5,
    range: 300,
    img: '',
  },
  {
    id: "Renault Zoe R110 Z.E. 50",
    name: "Renault Zoe R110 Z.E. 50 ®",
    label: "Renault Zoe R110 Z.E. 50 ®",
    value: "Renault Zoe R110 Z.E. 50",
    power: 52,
    consumption: 17.4,
    range: 395,
    img: '',
  },
  {
    id: "Renault Zoe R135 Z.E. 50",
    name: "Renault Zoe R135 Z.E. 50 ®",
    label: "Renault Zoe R135 Z.E. 50 ®",
    value: "Renault Zoe R135 Z.E. 50",
    power: 52,
    consumption: 17.7,
    range: 385,
    img: '',
  },
  {
    id: "Smart EQ Fortwo",
    name: "Smart EQ Fortwo ®",
    label: "Smart EQ Fortwo ®",
    value: "Smart EQ Fortwo",
    power: 16.7,
    consumption: 16.1,
    range: 133,
    img: '',
  },
  {
    id: "BMW i3",
    name: "BMW i3 ®",
    label: "BMW i3 ®",
    value: "BMW i3",
    power: 37.9,
    consumption: 15.3,
    range: 308,
    img: '',
  },
  {
    id: "BMW i3s",
    name: "BMW i3s ®",
    label: "BMW i3s ®",
    value: "BMW i3s",
    power: 37.9,
    consumption: 16.1,
    range: 283,
    img: '',
  },
  {
    id: "Opel Corsa-e",
    name: "Opel Corsa-e ®",
    label: "Opel Corsa-e ®",
    value: "Opel Corsa-e",
    power: 45,
    consumption: 16.6,
    range: 334,
    img: '',
  },
  {
    id: "Fiat 500e 23.8 kWh",
    name: "Fiat 500e 23.8 kWh ®",
    label: "Fiat 500e 23.8 kWh ®",
    value: "Fiat 500e 23.8 kWh",
    power: 23.8,
    consumption: 13,
    range: 190,
    img: '',
  },
  {
    id: "Fiat 500e 42 kWh ",
    name: "Fiat 500e 42 kWh  ®",
    label: "Fiat 500e 42 kWh  ®",
    value: "Fiat 500e 42 kWh ",
    power: 37.3,
    consumption: 14.5,
    range: 312,
    img: '',
  },
];
